import type { ReactNode } from 'react';
import { GovIcon, GovMessage } from '@gov-design-system-ce/react';
import type { ExtraConfig } from '@gov-nx/core/app';
import { useLocale } from '@gov-nx/core/service';
import { useProfileRezaListContext } from '@gov-nx/module/page';
import { ErrorStatusBanner, InfoBanner, LayoutGap } from '@gov-nx/ui/web';
import { MarkdownRender } from '../../Markdown/MarkdownRender';
import { ProfileContentLayout } from '../profil-ROB/ProfileContentLayout';
import { ProfileRezaListRender } from './ProfileRezaListRender';
import { ProfileRezaViewSkeleton } from './ProfileRezaViewSkeleton';

type ProfileRezaListProps =
	ExtraConfig['profileRoutes']['rezaProfileConfig']['profileRezaView'] & {
		navigation: ReactNode;
	};

export const ProfileRezaView = ({
	navigation,
	...profileRezaViewConfig
}: ProfileRezaListProps) => {
	const { code, isNoItems, isLoading, isError, zmocnenecData, zmocnitelData } =
		useProfileRezaListContext();
	const { t } = useLocale(code);

	if (isLoading) {
		return <ProfileRezaViewSkeleton />;
	}

	if (isError) {
		return <ErrorStatusBanner code={code} />;
	}

	return (
		<ProfileContentLayout {...profileRezaViewConfig.profileContentLayout}>
			{navigation}
			<LayoutGap
				gap="xl"
				className="mt-(--templates-margin-xl)!">
				<GovMessage
					color="neutral"
					type="subtle"
					icon={
						<GovIcon
							type="components"
							name="info-circle-fill"
						/>
					}>
					<MarkdownRender>
						{t('profil-reza.text.vice-informaci')}
					</MarkdownRender>
				</GovMessage>
				{isNoItems ? (
					<InfoBanner
						headline={t('stav.chyba.zatim-tu-nic-neni')}
						text={t('stav.chyba.nenasli-jsme-zadne-udaje')}
						orientation="horizontal"
					/>
				) : null}
				<ProfileRezaListRender
					headline={t('profil-reza.nadpis.koho-muzu-zastupovat')}
					data={zmocnenecData}
				/>
				<ProfileRezaListRender
					headline={t('profil-reza.nadpis.kdo-muze-zastupovat-me')}
					data={zmocnitelData}
				/>
			</LayoutGap>
		</ProfileContentLayout>
	);
};
